import { useTheme } from "@/theme";
import { site } from "@/content";

/**
 * Переключатель темы.
 *
 * Меняет тему на месте: адрес страницы остаётся прежним, класс `dark`
 * вешается на <html>, Tailwind перекрашивает `dark:`-утилиты.
 * Оформление кнопки следует текущей теме — отдельные варианты не нужны.
 */
export default function ThemeToggle() {
  const { isDark, toggleTheme } = useTheme();

  const label = isDark ? site.a11y.themeLight : site.a11y.themeDark;

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer bg-stone-100 hover:bg-stone-200 text-stone-600 dark:bg-white/[0.08] dark:hover:bg-white/[0.16] dark:text-white/80"
      aria-label={label}
      title={label}
      aria-pressed={isDark}
    >
      <i
        className={`${isDark ? "ri-sun-line" : "ri-moon-line"} text-sm`}
        aria-hidden="true"
      ></i>
    </button>
  );
}
